import { defineElement, PUB_SUB_EVENTS } from "./gw.js";
import { publish, subscribe } from "./pubsub.js";
class ConfigToggle extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.init();
  }

  init() {
    this.key = this.getAttribute("key");
    this.buttons = [...this.querySelectorAll("button")];
    this.values = this.buttons.map((button) => button.dataset.value);
    this.select(this.selectedButton);
  }

  connectedCallback() {
    this.addEventListener("click", this.onClick);
  }

  get dataKey() {
    return `RumoredConfig-${this.key}`;
  }

  get storedValue() {
    return localStorage.getItem(this.dataKey);
  }

  get initialValue() {
    var _a;
    const storedValue = this.storedValue;
    if (storedValue !== null && typeof storedValue !== "undefined") {
      return storedValue;
    }
    return (
      ((_a = this.buttons.find((button) => button.dataset.selected)) == null
        ? void 0
        : _a.dataset.value) ?? this.values[0]
    );
  }

  get currentValue() {
    return this._currentValue ?? this.initialValue;
  }

  set currentValue(value) {
    this._currentValue = value;
    localStorage.setItem(this.dataKey, value);
  }

  onClick(event) {
    const button = event.target.closest("button");
    if (!button) return;
    this.select(button);
  }

  deselectButton(button) {
    button.dataset.selected = false;
    button.setAttribute("aria-pressed", "false");
  }

  selectButton(button) {
    button.dataset.selected = true;
    button.setAttribute("aria-pressed", "true");
  }

  get selectedButton() {
    return this.buttons.find(
      (button) => button.dataset.value === this.currentValue,
    );
  }

  select(button) {
    const previousValue = this.currentValue;
    this.buttons.forEach(this.deselectButton);
    this.selectButton(button);
    this.currentValue = button.dataset.value;
    const eventKey = PUB_SUB_EVENTS.configValueChange;
    const eventData = {
      key: this.key,
      value: this.currentValue,
      previousValue,
    };
    publish(eventKey, eventData);
    publish(`${eventKey}:${this.key}`, eventData);
  }
}
defineElement("config-toggle", ConfigToggle);
class ConfigValueController {
  constructor(configKeys) {
    this.configKeys = configKeys;
    this.init();
  }

  init() {
    if ("configValueController" in window) {
      window.configValueController.destroy();
    }
    window.configValueController = this;
    this.subscribe();
    for (const key of this.configKeys) {
      const value = localStorage.getItem(`RumoredConfig-${key}`);
      if (value) {
        this.propagateConfigValue({ key, value });
      }
    }
  }

  destroy() {
    this.eventUnsubscriber();
  }

  propagateConfigValue({ key, value: configValue }) {
    const targets = [
      ...document.querySelectorAll(`[data-config-key="${key}"]`),
    ];
    for (const target of targets) {
      if (target.hasAttribute("data-content")) {
        const content = JSON.parse(target.getAttribute("data-content"));
        const value = content[configValue];
        if (value) {
          target.textContent = value;
        }
      } else if (target.hasAttribute("data-value"));
    }
  }

  subscribe() {
    this.eventUnsubscriber = subscribe(
      PUB_SUB_EVENTS.configValueChange,
      this.propagateConfigValue,
    );
  }
}
if (!("configValueController" in window)) {
  new ConfigValueController(["size-unit"]);
}
